﻿namespace WebPortal.Dialog {
    const cSXCAURL = "https://smca.swisscom.com";

    const mailregex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    export class Login {
        constructor() { this.init(); }

        private init(): void {
            $("#email").focus();

            // Authentication Provider selektieren
            let AuthenticationLevelID = parseInt(localStorage.getItem("AuthenticationLevelID"));
            if (!!AuthenticationLevelID && AuthenticationLevelID == 2) {
                $("#select_AuthenticationLevelID").selectpicker("val", 2);
            }

            $("#login").off().on("click", () => { return this.doSignIn(); });

            // verhinderung von Postbacks bei Enter Klicks
            $("#login").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSignIn();
                }
            });

            $("#email").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSignIn();
                }
            });

            $("#password").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSignIn();
                }
            });

            $('#select_AuthenticationLevelID').on('changed.bs.select', function (e) {
                localStorage.setItem("AuthenticationLevelID", $("#select_AuthenticationLevelID").val());
            });

            $("#bt_WebToken_Verify").off().on("click", () => { return this.doWebTokenAuth(); });
            $("#bt_WebToken_Verify").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doWebTokenAuth();
                }
            });
            $("#tb_WebToken").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doWebTokenAuth();
                }
            });

            $("#bt_SMSTan_Verify").off().on("click", () => { return this.doSMSTanAuth(); });
            $("#bt_SMSTan_Verify").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSMSTanAuth();
                }
            });
            $("#tb_SMSTan").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSMSTanAuth();
                }
            });

            $("#bt_MobileID_Error_Retry").off().on("click", () => { return this.doMobileIDAuth(); });
            $("#bt_MobileID_Error_Retry").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doMobileIDAuth();
                }
            });

            $("#bt_Redirect_to_SXCA").off().on("click", () => { return this.doRedirectToSXCA(); });
            $("#bt_Redirect_to_SXCA").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doRedirectToSXCA();
                }
            });

            // Events um den aktuellen Tenant zu setzen
            $("#bt_TenantSelection_log_in").off().on("click", () => { return this.doSetSelectedTenant(); });
            $("#bt_TenantSelection_log_in").keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.doSetSelectedTenant();
                }
            });
            //$("#select_TenantSelection").on('changed.bs.select', this.doSetSelectedTenant);

            WebPortalHubObj.client.ReceiveContextId = (_ContextId: string) => {
                console.log("Received session ID from SignalR:", _ContextId);

                // Send session ID to backend API to store in a cookie
                fetch("/Auth/SetContextCookie", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: `contextId=${encodeURIComponent(_ContextId)}`,
                })
                    .then(response => response.json())
                    .catch(error => console.error("Error setting cookie:", error));
            };

            WebPortalHubObj.client.ShowCauseInLogin = (_Cause: any) => {
                $("#pn_progress_Login").addClass("hidden");
                $("#pn_login_Error").removeClass("hidden");
                $("#tb_Login_Cause").html(_Cause);
            };

            WebPortalHubObj.client.ReloadWithQueryString = (_Request: string) => {
                const joinerId = WebPortal.Misc.getUrlParameter('id');
                const token = WebPortal.Misc.getUrlParameter('token');
                if (joinerId && token) {
                    _Request += `&id=${joinerId}&token=${token}`;
                }
                window.location.href =
                    window.location.protocol + "//" + window.location.host + window.location.pathname +
                    "?ma_se_request=" + _Request;
            };

            WebPortalHubObj.client.ShowSMSTanInLogin = (_Cause: any, _State: number) => {
                $("#pn_login").addClass("hidden");
                $("#email").blur();
                $("#password").blur();
                $("#pn_SMSTan").removeClass("hidden");
                $("#tb_SMSTan").focus();

                if (_State === 1) {
                    $("#tb_SMSTan_Cause").html(_Cause);
                    $("#pn_SMSTan_Error").addClass("hidden");
                }
                if (_State === 2) {
                    $("#tb_SMSTan_Error_Cause").html(_Cause);
                    $("#pn_SMSTan_Error").removeClass("hidden");
                }
            };

            WebPortalHubObj.client.ShowWebTokenInLogin = (_Cause: any, _State: number) => {
                $("#pn_login").addClass("hidden");
                $("#email").blur();
                $("#password").blur();
                $("#pn_WebToken").removeClass("hidden");
                $("#tb_WebToken").focus();

                if (_State === 1) {
                    $("#tb_WebToken_Cause").html(_Cause);
                    $("#pn_WebToken_Error").addClass("hidden");
                }
                if (_State === 2) {
                    $("#tb_WebToken_Error_Cause").html(_Cause);
                    $("#pn_WebToken_Error").removeClass("hidden");
                }
            };

            WebPortalHubObj.client.ShowMobileIDInLogin = (_Cause: any, _State: number) => {
                $("#pn_login").addClass("hidden");
                $("#email").blur();
                $("#password").blur();
                $("#pn_MobileID").removeClass("hidden");

                if (_State === 1) {
                    $("#tb_MobileID_Cause").html(_Cause);
                    $("#pn_MobileID_Error").addClass("hidden");
                }
                if (_State === 2) {
                    $("#tb_MobileID_Error_Cause").html(_Cause);
                    $("#pn_MobileID_Error").removeClass("hidden");
                }
            };

            WebPortalHubObj.client.ShowOidbLogin = () => {
                $("#pn_login").addClass("hidden");
                $("#email").blur();
                $("#password").blur();
                $("#tb_Oidb_Cause").html("Logging in...");
                $("#pn_Oidb").removeClass("hidden");
            };

            WebPortalHubObj.client.HideOidbLogin = () => {
                $("#pn_Oidb").addClass("hidden");
            };

            WebPortalHubObj.client.ShowCauseInSMSTanCheck = (_Cause: any) => {
                $("#pn_progress_SMSTan").addClass("hidden");
                $("#pn_SMSTan_Error").removeClass("hidden");
                $("#tb_SMSTan_Error_Cause").html(_Cause);
            };

            WebPortalHubObj.client.ShowCauseInWebTokenCheck = (_Cause: any) => {
                $("#pn_progress_WebToken").addClass("hidden");
                $("#pn_WebToken_Error").removeClass("hidden");
                $("#tb_WebToken_Error_Cause").html(_Cause);
            };

            WebPortalHubObj.client.ShowCauseInMobileIDCheck = (_Cause: any) => {
                $("#pn_progress_MobileID").addClass("hidden");
                $("#pn_MobileID_Error").removeClass("hidden");
                $("#tb_MobileID_Error_Cause").html(_Cause);
                $("#bt_MobileID_Error_Retry").removeClass("hidden");
            };

            WebPortalHubObj.client.ShowCauseInOidbCheck = (_Cause: any) => {
                $("#pn_progress_Oidb").addClass("hidden");
                $("#pn_Oidb_Error").removeClass("hidden");
                $("#tb_Oidb_Error_Cause").html(_Cause);
            };

            WebPortalHubObj.client.ShowTenantSelection = Misc.ShowTenantSelection;
        }

        private doSignIn(): boolean {
            let email: string = $("#email").val();
            let password: string = $("#password").val();
            let authenticationLevelID: number = $("#select_AuthenticationLevelID").val();
            if ((!!email) && mailregex.test(email) &&
                (!!password) && 
                (!!authenticationLevelID) && (authenticationLevelID == 1 || authenticationLevelID == 2)) {
                $("#pn_login_Error").addClass("hidden");
                $("#pn_progress_Login").removeClass("hidden");
                WebPortalHubObj.server.doLogin(email, password, authenticationLevelID, window.location.pathname);
            } else {
                $("#tb_Login_Cause").text("Valid E-Mail-Address and Password required!");
                $("#pn_login_Error").removeClass("hidden");
            }
            return (false);
        }

        private doSMSTanAuth(): boolean {
            let email: string = $("#email").val();
            let password: string = $("#password").val();
            let SMSTan: string = $("#tb_SMSTan").val();
            if ((!!email) && mailregex.test(email) && (!!password) && (!!SMSTan)) {
                $("#pn_login_Error").addClass("hidden");
                let shaObj = new jsSHA("SHA-512", "TEXT");
                shaObj.update(SMSTan.toUpperCase());
                let SMSTanHash: string = shaObj.getHash("HEX");
                $("#pn_progress_SMSTan").removeClass("hidden");
                fetch("/Auth/GetContextId", { method: "GET", credentials: "include" })
                    .then(response => response.json())
                    .then(data => {
                        let contextId = data.contextId || null;
                        WebPortalHubObj.server.doSMSTanCheck(window.location.pathname, SMSTanHash.toUpperCase(), contextId);
                    })
                    .catch(error => {
                        console.error("Error fetching ContextId:", error);
                    });
            } else {
                $("#tb_SMSTan_Error_Cause").text("SMS Tan required!");
                $("#pn_SMSTan_Error").removeClass("hidden");
            }
            return (false);
        }

        private doWebTokenAuth(): boolean {
            let email: string = $("#email").val();
            let password: string = $("#password").val();
            let WebToken: string = $("#tb_WebToken").val();
            if ((!!email) && mailregex.test(email) && (!!password) && (!!WebToken)) {
                $("#pn_login_Error").addClass("hidden");
                let shaObj = new jsSHA("SHA-512", "TEXT");
                shaObj.update(WebToken.toUpperCase());
                let WebTokenHash: string = shaObj.getHash("HEX");
                $("#pn_progress_WebToken").removeClass("hidden");
                fetch("/Auth/GetContextId", { method: "GET", credentials: "include" })
                    .then(response => response.json())
                    .then(data => {
                        let contextId = data.contextId || null;
                        WebPortalHubObj.server.doWebTokenCheck(window.location.pathname, WebTokenHash.toUpperCase(), contextId);
                    })
                    .catch(error => {
                        console.error("Error fetching ContextId:", error);
                    });
            } else {
                $("#tb_WebToken_Error_Cause").text("Web Token required!");
                $("#pn_WebToken_Error").removeClass("hidden");
            }
            return (false);
        }

        private doMobileIDAuth(): boolean {
            let email: string = $("#email").val();
            let password: string = $("#password").val();
            if ((!!email) && mailregex.test(email) && (!!password)) {
                $("#pn_login_Error").addClass("hidden");
                $("#pn_MobileID_Error").addClass("hidden");
                $("#pn_progress_MobileID").removeClass("hidden");
                let TransactionID: string = this.GenerateTransactionToken();
                $("#tb_MobileID_Cause").html("Enter your Mobile ID PIN on your mobile phone.<br />(Transaction ID: " + TransactionID + ")");
                fetch("/Auth/GetContextId", { method: "GET", credentials: "include" })
                    .then(response => response.json())
                    .then(data => {
                        let contextId = data.contextId || null;
                        WebPortalHubObj.server.doMobileIDCheck(TransactionID, window.location.pathname, contextId);
                    })
                    .catch(error => {
                        console.error("Error fetching ContextId:", error);
                    });
            } else {
                $("#bt_MobileID_Error_Retry").addClass("hidden");
                $("#tb_MobileID_Error_Cause").text("MobileID Error, Press F5 to retry!");
                $("#pn_MobileID_Error").removeClass("hidden");
            }
            return (false);
        }

        /// <summary>
        /// Generiert für MobileID einen 7-stelligen Transaktionstoken mit einer Raute vorne dran #A1B2C35
        /// </summary>
        /// <returns>Der generierte Token</returns>
        private GenerateTransactionToken(): string {
            let AllowedChars: string = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            let TTLength: number = 7;
            let result: string = "#";

            for (var i = 0; i < TTLength; i++)
                result += AllowedChars.charAt(Math.floor(Math.random() * AllowedChars.length));

            return result;
        }

        /// <summary>
        /// Fenster mit Zugang zu SXCA öffnen
        /// </summary>
        /// <returns>false, damit kein Postback ausgeführt wird</returns>
        private doRedirectToSXCA(): boolean {
            window.location.href = cSXCAURL;
            return (false);
        }

        /// <summary>
        /// Setzt den aktuellen Tenant (wenn es mehrere Tenant gibt)
        /// </summary>
        /// <returns>false, damit kein Postback ausgeführt wird</returns>
        private doSetSelectedTenant(): boolean {
            let selectedTenantId: number = $("#select_TenantSelection :selected").val();
            let selectedTenant: string = $("#select_TenantSelection :selected").text();
            localStorage.setItem("TenantId", selectedTenantId.toString());
            WebPortalHubObj.server.doSetSelectedTenant(tempRequest, selectedTenantId, selectedTenant, loginTenantId);
            return (false);
        }
    }
}